import React from "react";
import { COLORS } from "rylak-common/src/constants";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";

export default function HoverText({ text, hoverContent, maxTooltipWidth }) {
    return (
        <div
            style={{
                borderBottom: ".125rem dotted " + COLORS.VERY_WEAK_TEXT,
                cursor: "pointer",
                width: "fit-content",
            }}
        >
            <TurnrTooltip title={text} content={hoverContent} maxTooltipWidth={maxTooltipWidth}>
                {text}
            </TurnrTooltip>
        </div>
    );
}
